import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=028dcf42"
import script from "./MultipleChoice.vue?vue&type=script&lang=js"
export * from "./MultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=028dcf42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports